import {createI18n} from "vue-i18n";
import koKR from "@/locale/ko.json"
import enUS from "@/locale/en.json"
import zhCN from "@/locale/zh.json"
import jaJP from "@/locale/ja.json"

const i18n = createI18n({
  locale : 'ko', // 기본 한국어
  fallbackLocale: 'ko', // 다국어 작동 안될 시 사용
  legacy: false, // script에서 사용할 경우 false
  messages: {
    ko : koKR, // 한국어
    en : enUS, // 영어
    zh : zhCN, // 중국어
    ja : jaJP // 일본어
  }
})

export default i18n;